var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CFE7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 23V21.2C34 20.0799 34 19.5198 33.782 19.092C33.5903 18.7157 33.2843 18.4097 32.908 18.218C32.4802 18 31.9201 18 30.8 18H25.2C24.0799 18 23.5198 18 23.092 18.218C22.7157 18.4097 22.4097 18.7157 22.218 19.092C22 19.5198 22 20.0799 22 21.2V23M22 34C21.07 34 20.605 34 20.2235 33.8978C19.1883 33.6204 18.3796 32.8117 18.1022 31.7765C18 31.395 18 30.93 18 30V27.8C18 26.1198 18 25.2798 18.327 24.638C18.6146 24.0735 19.0735 23.6146 19.638 23.327C20.2798 23 21.1198 23 22.8 23H33.2C34.8802 23 35.7202 23 36.362 23.327C36.9265 23.6146 37.3854 24.0735 37.673 24.638C38 25.2798 38 26.1198 38 27.8V30C38 30.93 38 31.395 37.8978 31.7765C37.6204 32.8117 36.8117 33.6204 35.7765 33.8978C35.395 34 34.93 34 34 34M31 26.5H34M25.2 38H30.8C31.9201 38 32.4802 38 32.908 37.782C33.2843 37.5903 33.5903 37.2843 33.782 36.908C34 36.4802 34 35.9201 34 34.8V33.2C34 32.0799 34 31.5198 33.782 31.092C33.5903 30.7157 33.2843 30.4097 32.908 30.218C32.4802 30 31.9201 30 30.8 30H25.2C24.0799 30 23.5198 30 23.092 30.218C22.7157 30.4097 22.4097 30.7157 22.218 31.092C22 31.5198 22 32.0799 22 33.2V34.8C22 35.9201 22 36.4802 22.218 36.908C22.4097 37.2843 22.7157 37.5903 23.092 37.782C23.5198 38 24.0799 38 25.2 38Z",
    stroke: "#0D67B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E2F1FD",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.c1b615d537a956df68837acfc7f5b2cf.svg";
export { ForwardRef as ReactComponent };